import { setAllCharts, setCurrentChart } from "redux/actions/charts.action";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const getChartsByStatus = (status, params = {}, signal) => {
  return (dispatch) => {
    return request(`Charts/Filtered`, "post", params, true, null, {
      signal,
    })
      .then(({ data }) => {
        dispatch(setAllCharts(data));
      })
      .catch((e) => {
        if (e?.name === "AbortError" || e?.message === "canceled") return;

        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const getChartsByUser = (guestId) => {
  return (dispatch) => {
    return request(`Charts/Completed`, "get", null, true, { guestId })
      .then(({ data }) => {
        dispatch(setAllCharts(data));
        return data;
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const getLegacyChart = (orderId, lineItemId) => {
  return (dispatch) => {
    return request(`Charts/`, "get", null, true, { orderId, lineItemId })
      .then(({ data }) => {
        setCurrentChart([data]);
        return [data];
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const submitChart = (data) => {
  return (dispatch) => {
    return request(`Charts/`, "post", data, true, null)
      .then(({ data }) => {
        dispatch(setCurrentChart(data));
        openNotificationWithIcon(
          "success",
          "Saved",
          "Chart saved successfully!"
        );
        return data;
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const updateChart = (data, chartId) => {
  return (dispatch) => {
    return request(`Charts/`, "put", data, true, { chartId })
      .then(({ data }) => {
        dispatch(setCurrentChart(data));
        // console.log(data)
        openNotificationWithIcon(
          "success",
          "Saved",
          "Chart saved successfully!"
        );
        return data;
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const assignNursePractitioner = (practionerStaffId, chartId) => {
  return request(`Charts/${chartId}/AssignPractioner`, "patch", null, true, {
    practionerStaffId,
  })
    .then(({ data }) => {
      // dispatch(setCurrentChart(data))
      // console.log(data)
      // openNotificationWithIcon('success', 'Submitted', 'Chart updated successfully!')
      return data;
    })
    .catch((e) => {
      openNotificationWithIcon(
        "error",
        "Error!",
        getServerErrorString(e));
    });
};

export const getChartNotes = (chartId) => {
  return request(`Charts/${chartId}/Notes`, "get", null, true, null)
    .then(({ data }) => {
      // dispatch(setCurrentChart(data))
      // console.log(data)
      // openNotificationWithIcon('success', 'Submitted', 'Chart updated successfully!')
      return data;
    })
    .catch((e) => {
      openNotificationWithIcon(
        "error",
        "Error!",
        getServerErrorString(e)
      );
    });
};

export const addChartNotes = (chartId, data) => {
  return request(`Charts/${chartId}/Notes`, "post", data, true, null)
    .then(({ data }) => {
      // dispatch(setCurrentChart(data))
      // console.log(data)
      // openNotificationWithIcon('success', 'Submitted', 'Chart updated successfully!')
      return data;
    })
    .catch((e) => {
      openNotificationWithIcon(
        "error",
        "Error!",
        getServerErrorString(e));
    });
};
